import React from 'react';

import { IconProps } from './type';

const GridIcon: React.FC<IconProps> = ({ className = '', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M17.4444 5C18.3036 5 19 5.69645 19 6.55556C19 7.41467 18.3036 8.11111 17.4444 8.11111C16.5853 8.11111 15.8889 7.41467 15.8889 6.55556C15.8889 5.69645 16.5853 5 17.4444 5Z"
      fill="currentColor"
    />
    <path
      d="M17.4444 10.4448C18.3036 10.4448 19 11.1413 19 12.0004C19 12.8595 18.3036 13.556 17.4444 13.556C16.5853 13.556 15.8889 12.8595 15.8889 12.0004C15.8889 11.1413 16.5853 10.4448 17.4444 10.4448Z"
      fill="currentColor"
    />
    <path
      d="M19 17.4445C19 16.5854 18.3036 15.8889 17.4444 15.8889C16.5853 15.8889 15.8889 16.5854 15.8889 17.4445C15.8889 18.3036 16.5853 19 17.4444 19C18.3036 19 19 18.3036 19 17.4445Z"
      fill="currentColor"
    />
    <path
      d="M12 5.00002C12.8591 5.00002 13.5556 5.69647 13.5556 6.55558C13.5556 7.41469 12.8591 8.11113 12 8.11113C11.1409 8.11113 10.4444 7.41469 10.4444 6.55558C10.4444 5.69647 11.1409 5.00002 12 5.00002Z"
      fill="currentColor"
    />
    <path
      d="M13.5556 12.0004C13.5556 11.1413 12.8591 10.4448 12 10.4448C11.1409 10.4448 10.4444 11.1413 10.4444 12.0004C10.4444 12.8595 11.1409 13.556 12 13.556C12.8591 13.556 13.5556 12.8595 13.5556 12.0004Z"
      fill="currentColor"
    />
    <path
      d="M12 15.8889C12.8591 15.8889 13.5556 16.5854 13.5556 17.4445C13.5556 18.3036 12.8591 19 12 19C11.1409 19 10.4444 18.3036 10.4444 17.4445C10.4444 16.5854 11.1409 15.8889 12 15.8889Z"
      fill="currentColor"
    />
    <path
      d="M8.11113 6.55558C8.11113 5.69647 7.41469 5.00002 6.55558 5.00002C5.69647 5.00002 5.00002 5.69647 5.00002 6.55558C5.00002 7.41469 5.69647 8.11113 6.55558 8.11113C7.41469 8.11113 8.11113 7.41469 8.11113 6.55558Z"
      fill="currentColor"
    />
    <path
      d="M6.55558 10.4448C7.41469 10.4448 8.11113 11.1413 8.11113 12.0004C8.11113 12.8595 7.41469 13.556 6.55558 13.556C5.69647 13.556 5.00002 12.8595 5.00002 12.0004C5.00002 11.1413 5.69647 10.4448 6.55558 10.4448Z"
      fill="currentColor"
    />
    <path
      d="M8.11114 17.4445C8.11114 16.5854 7.41469 15.8889 6.55558 15.8889C5.69647 15.8889 5.00002 16.5854 5.00002 17.4445C5.00002 18.3036 5.69647 19 6.55558 19C7.41469 19 8.11114 18.3036 8.11114 17.4445Z"
      fill="currentColor"
    />
  </svg>
);

export default GridIcon;
